import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { useGeminiLanguage } from '../hooks/useGeminiLanguage';
import { getCanvasMessages } from '../utils/canvasI18n';
import HowToPinModal from './HowToPinModal';

/**
 * Help control on a Do next step, or a refresh control when `onRefresh` is set.
 * The header next-insight button refreshes; destination rows still open how-to-pin.
 */
const HowToPinButton = ({
  className = '',
  stale = false,
  loading = false,
  onRefresh,
}) => {
  const { geminiLanguage } = useGeminiLanguage();
  const messages = getCanvasMessages(geminiLanguage);
  const [open, setOpen] = useState(false);
  const isRefresh = typeof onRefresh === 'function';
  const refreshable = stale && !loading && isRefresh;
  const label = isRefresh ? messages.refreshDoNext : messages.howToPinTitle;
  const tooltip = isRefresh
    ? (refreshable ? messages.refreshDoNextStaleTooltip : messages.refreshDoNextTooltip)
    : messages.howToPinTitle;

  return (
    <>
      <Tooltip title={tooltip} arrow placement="top">
        <IconButton
          size="small"
          className={[
            'board-how-to-pin-inline',
            className,
            stale ? 'is-stale' : '',
            loading ? 'is-loading' : '',
          ].filter(Boolean).join(' ')}
          aria-label={label}
          onClick={(event) => {
            event.stopPropagation();
            if (refreshable) {
              onRefresh();
              return;
            }
            if (isRefresh || (stale && loading)) return;
            setOpen(true);
          }}
        >
          {isRefresh
            ? <RefreshRoundedIcon fontSize="inherit" />
            : <QuestionMarkIcon fontSize="inherit" />}
        </IconButton>
      </Tooltip>
      {isRefresh ? null : (
        <HowToPinModal open={open} onClose={() => setOpen(false)} messages={messages} />
      )}
    </>
  );
};

export default HowToPinButton;
